import BNutritionHowCanHelp from './BNutritionHowCanHelp'

export default BNutritionHowCanHelp
